import React from 'react';
import { InPageSpinner } from '@components/spinners/in-page-spinner';
import styles from './styles.module.scss';

/*
 * Centers the shared InPageSpinner both horizontally and vertically — InPageSpinner only
 * centers itself horizontally on its own, so every full-panel loading state in APIM uses
 * this wrapper instead of the bare spinner.
 */
export function PageLoader() {
    return (
        <div className={styles.loaderContainer}>
            <InPageSpinner />
        </div>
    );
}
